module.exports = __webpack_public_path__ + "ci_vendor_email.4223c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/ci_vendor_email.svg
// module id = ./src/_asset/sources/assets/images/@svg/ci_vendor_email.svg
// module chunks = main